import React, { Component } from "react"
import { Container, Row, Col, Spinner, Button, Form } from "react-bootstrap"
import { Subscription } from "rxjs"
import GeneralInformation, { PersonDemographicRecord, PersonDemographicObject, RegMode } from "../../../api/OrderResults/OrderResultModel/GeneralInformation"
import { GeneralInformationGet, GetPersonDemographicsDetail } from "../../../api/OrderResults/GeneralInformationGet"
import { toast } from "react-toastify"
import { AppState } from "../../../AppState"
import { connect } from "react-redux"
import FormatSSN from "../../../formatters/FormatSSN"
import FormatDate from "../../../formatters/FormatDate"
import { BuildUserAccess } from "../../../authentication/BuildUserAccess"
import UserAccessSettings from "../../../authentication/UserAccessSettings";
import 'react-datepicker/dist/react-datepicker.css'
import { GeneralInformationSave, UpdatePersonDemographic, SaveRegulatoryMode } from "../../../api/OrderResults/GeneralInformationGet"
import FormatError from "../../../formatters/FormatError"
import { isCompanyAdmin, isPortalAdmin } from "../../../authentication/isAdminRole"
import { GetSelectedAssignedClinic } from "../../../authentication/SelectedCompany/CompanySelectionDrivenSelectors"
import EmployesToMergeGrid from "./EmployesToMergeGrid"
import RegulatoryMode from "../../../api/LabService/LabServiceModel/RegulatoryMode"
import LabServiceRegulatoryModesGetObservable from "../../../api/LabService/LabServiceRegulatoryModesGet"

type CreateRegModeString = {
  EmpCat: string
  EmployeeCategoryID: number
  PersonRegModeEmpCatID: number
  Primary: boolean
  RegMode: string
  RegulatoryModeID: number
}
function regulatoryModeValue(results: CreateRegModeString[]): string {
  if (results.length > 0) {
    let primary: CreateRegModeString | undefined = results.find(item => item.Primary)
    let result: string = primary ? primary.RegMode : ""
    let otherRegModes: string = results.filter(item => !item.Primary).map(item => item.RegMode).join(", ")
    if (otherRegModes !== "") {
      result = `${result} (${otherRegModes})`
    }
    return result
  } else {
    return "N/P"
  }
}
const HeaderRow = (props: { title: string }) =>
  <Row>
    <Col><h5 className="pt-3 pb-2">{props.title}</h5></Col>
  </Row>



const InfoRow = (props: { title: string, value: string | null, className?: string }) => <Row className="py-1">
  <Col xs={6} md={6}><span className="caption">{props.title}</span></Col>
  <Col xs={6} md={6}><span className={props.className}>{props.value}</span></Col>
</Row>



interface MergeEmployeeProps {
  PersonID: number
  isGov?: boolean
}

interface MergeEmployeeAuthProps {
  userPermissions?: UserAccessSettings
  isPortalAdmin: boolean
  isCompanyAdmin: boolean
  companyID: number
}

interface MergeEmployeeState {
  data?: GeneralInformation,
  isGeneralInfoLoading: boolean,
  isRegulatoryModesLoading: boolean
  isRegulatoryModesLoaded: boolean
  regulatoryModes: RegulatoryMode[]

}
export class MergeEmployee extends Component<MergeEmployeeProps & MergeEmployeeAuthProps, MergeEmployeeState> {
  state: MergeEmployeeState = {
    data: undefined,
    isGeneralInfoLoading: false,
    isRegulatoryModesLoading: false,
    isRegulatoryModesLoaded: false,
    regulatoryModes: []
  }
  generalInfoSubscription?: Subscription
  generalInfoSaveSubscription?: Subscription
  regulatoryModesSubscription?: Subscription

  componentDidMount() {
    this.loadGeneralInfo(this.props.PersonID)
    this.loadRegulatoryModes()
  }

  componentWillUnmount() {
    this.generalInfoSubscription && this.generalInfoSubscription.unsubscribe()
    this.generalInfoSaveSubscription && this.generalInfoSaveSubscription?.unsubscribe()
    this.regulatoryModesSubscription && this.regulatoryModesSubscription.unsubscribe()
  }

  loadGeneralInfo(PersonID: number) {
    this.setState({ isGeneralInfoLoading: true })
    this.generalInfoSubscription && this.generalInfoSubscription.unsubscribe()
    this.generalInfoSubscription = GeneralInformationGet(PersonID).subscribe(
      (data: GeneralInformation) => this.setState({ data: data }),
      (error) => {
        this.setState({ isGeneralInfoLoading: false })
        toast.error(FormatError(error))
      },
      () => this.setState({ isGeneralInfoLoading: false })
    )
  }

  loadRegulatoryModes = () => {

    if (this.state.isRegulatoryModesLoaded) {
      return
    }
    this.setState({ isRegulatoryModesLoading: true, regulatoryModes: [] })
    this.regulatoryModesSubscription && this.regulatoryModesSubscription.unsubscribe()
    this.regulatoryModesSubscription = LabServiceRegulatoryModesGetObservable(true).subscribe(
      (data: RegulatoryMode[]) => this.setState({
        regulatoryModes: data,
        isRegulatoryModesLoading: false,
        isRegulatoryModesLoaded: true
      }),
      () => this.setState({ isRegulatoryModesLoading: false })
    )
  }
  createDonorIdTypeRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="Company ID Type" value={data.CompanyPrimaryID} className="text-uppercase" />

  }
  createDonorIdRow = () => {
    const data: GeneralInformation = this.state.data!
    const idType = data.PrimaryIDType
    let val = data.PrimaryIDValue
    if (data.CompanyPrimaryID === "SSN") {
      if (data.SSN) {
        val = data.SSN
      }
      val = FormatSSN(val)
    }
    return <InfoRow title="Donor ID" value={val} className="text-uppercase" />

  }

  createFirstNameRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="First Name" value={data.FirstName} className="text-uppercase" />
  }


  createLastNameRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="Last Name" value={data.LastName} className="text-uppercase" />

  }


  createCompanyRow = (name: string) => {
    return <InfoRow title="COMPANY" value={name} />
  }

  createLocationRow = (name: string) => {
    return <InfoRow title="LOCATION" value={name} />
  }
  createEmployerIdRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="EMPLOYER ID" value={data.Employer} className="text-uppercase" />

  }

  createAlternateIdRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="ALTERNATE ID" value={data.Alternate} className="text-uppercase" />
  }



  createSSNRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="SSN" value={FormatSSN(data.SSN || "")} />
  }


  createDriverIdRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="DRIVER ID" value={data.Driver} className="text-uppercase" />
  }

  createGenderRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="GENDER" value={`${data.Gender === "F" ? "Female" : ""}${data.Gender === "M" ? "Male" : ""}`} />
  }

  createDateOfBirthRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="DATE OF BIRTH" value={FormatDate(data.DOB || "")} />
  }

  createHireDateRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="HIRE DATE" value={FormatDate(data.HireDate || "")} />
  }

  createTerminationDateRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="TERMINATION DATE" value={FormatDate(data.TerminationDate) || "N/P"} />
  }

  createInactiveRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="ACTIVE" value={!data.Inactive ? "Yes" : "No"} />
  }

  createRegulatoryModeRow = () => {
    const data: GeneralInformation = this.state.data!
    return <InfoRow title="REGULATORY MODE" value={regulatoryModeValue(data.RegModCatList)} className="primary" />
  }

  createInfoRows = () => {
    const { isGov } = this.props
    const data: GeneralInformation = this.state.data!
    const donorIdTypeRow = this.createDonorIdTypeRow()
    const donorIdRow = this.createDonorIdRow()
    const firstNameRow = this.createFirstNameRow()
    const lastNameRow = this.createLastNameRow()
    const companyRow = this.createCompanyRow(data.Company)
    const locationRow = this.createLocationRow(data.Location)
    const employerIdRow = this.createEmployerIdRow();
    const driverIdRow = this.createDriverIdRow()
    const ssnRow = this.createSSNRow()
    const alternateIdRow = this.createAlternateIdRow()
    const genderRow = this.createGenderRow()
    const dateOfBirthRow = this.createDateOfBirthRow()
    const hireDateRow = this.createHireDateRow()
    const terminationDateRow = this.createTerminationDateRow()
    const activeRow = this.createInactiveRow()
    const regulatoryModeRow = this.createRegulatoryModeRow()


    const result = {
      donorIdTypeRow: donorIdTypeRow,
      donorIdRow: donorIdRow,
      firstNameRow: firstNameRow,
      lastNameRow: lastNameRow,
      companyRow: companyRow,
      locationRow: locationRow,
      employerIdRow: employerIdRow,
      driverIdRow: driverIdRow,
      ssnRow: ssnRow,
      alternateIdRow: alternateIdRow,
      genderRow: genderRow,
      dateOfBirthRow: dateOfBirthRow,
      hireDateRow: hireDateRow,
      terminationDateRow: terminationDateRow,
      activeRow: activeRow,
      regulatoryModeRow: regulatoryModeRow,
    }
    return result
  }



  render() {
    const { isGov } = this.props
    if (!this.state.data) {
      return this.state.isGeneralInfoLoading ? <Spinner animation="border" size="sm" /> : <></>
    }
    const companyAdminOfAnotherCompany = this.props.isCompanyAdmin && this.props.companyID !== this.state.data.CompanyID

    const infoRows = this.createInfoRows();


    return (
      <Container className="general-info px-4 pb-4 pt-3">
        <Container className="px-4 pb-4 pt-3">
          <Row>
            <Col xs={12} lg={6}>
              <HeaderRow title="DONOR INFO" />
            </Col>
            <Col xs={12} lg={6}>
              <HeaderRow title="" />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={6}>
              {infoRows.companyRow}
              {infoRows.donorIdTypeRow}
              {infoRows.firstNameRow}
              {infoRows.employerIdRow}
              {infoRows.ssnRow}
              {infoRows.genderRow}
              {infoRows.hireDateRow}
              {infoRows.activeRow}
            </Col>
            <Col xs={12} lg={6}>
              {infoRows.locationRow}
              {infoRows.donorIdRow}
              {infoRows.lastNameRow}
              {infoRows.driverIdRow}
              {infoRows.alternateIdRow}
              {infoRows.dateOfBirthRow}
              {infoRows.terminationDateRow}
              {infoRows.regulatoryModeRow}
            </Col>
          </Row>
        </Container>
        <Container>
          <HeaderRow title="SEARCH FOR DONOR TO MERGE" />
        </Container>
        <EmployesToMergeGrid PersonID={this.props.PersonID} CompanyID={this.props.companyID} isGov={this.props.isGov || false}></EmployesToMergeGrid>
      </Container>
    )
  }

}

function mapStateToProps(state: AppState): MergeEmployeeAuthProps {
  const userAccess = BuildUserAccess(state)
  const selectedCompany = GetSelectedAssignedClinic(state)
  return {
    userPermissions: userAccess,
    isPortalAdmin: isPortalAdmin(state),
    isCompanyAdmin: isCompanyAdmin(state),
    companyID: selectedCompany?.AccountID || 0,
  }
}
const ConnectedMergeEmployee = connect(mapStateToProps)(MergeEmployee)
export default ConnectedMergeEmployee
